import { HoardingGroup } from "../hoardings/hoardings-group";

export class ConflictGroup {
    hoardingGroups: HoardingGroup[] = [];
    hoardingGroup: HoardingGroup = new HoardingGroup();
}
